import styled from 'styled-components/macro'

export const Widget = styled.div`
  background: transparent;
  border-radius: 16px;
  padding: 0;
`
